<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
              variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h5 mt-2 mb-4">Interface de validation des inscriptions pour {{ mainStore.module.nom }}
            </div>

            <v-tabs v-model="tab" bg-color="primary">
              <v-tab value="document">Par document coureur</v-tab>

              <v-tab value="licence"
                v-if="mainStore.authAdmin.isSportipsAdmin && mainStore.ffa_num_competition != ''">par
                webservice</v-tab>
              <v-tab value="pps" v-if="mainStore.authAdmin.isSportipsAdmin && mainStore.ffa_num_competition != ''">par
                PPS</v-tab>

            </v-tabs>

            <v-card-text>
              <v-window v-model="tab">
                <v-window-item value="document">
                  <Validation_Documents></Validation_Documents>
                </v-window-item>

                <v-window-item value="licence">
                  <Validation_Licences></Validation_Licences>
                </v-window-item>
                <v-window-item value="pps">
                  <Validation_PPS></Validation_PPS>
                </v-window-item>

              </v-window>
            </v-card-text>



          </div>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import AdminService from "@/services/admin.service.js";
import Validation_Documents from "@/components/Administration/Validation_Inscriptions/Validation_Documents.vue";
import Validation_Licences from "@/components/Administration/Validation_Inscriptions/Validation_Licences.vue";
import Validation_PPS from "@/components/Administration/Validation_Inscriptions/Validation_PPS.vue";
export default {
  components: {
    Validation_Documents,
    Validation_Licences,
    Validation_PPS,
  },
  data() {
    return {
      snackbar_success: false,
      tab: "documents",
      validation_document: {},
      validation_webservice: {},
      inscription_to_validate: {},
      inscription_webservice_to_validate: {},
      show_validate: false,
      show_reject: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    nb_inscrits_to_validate_webservice() {
      if (!this.validation_webservice || !this.validation_webservice.list_inscriptions) return 0;

      return this.validation_webservice.list_inscriptions.length;
    },
    nb_inscrits_to_validate() {
      if (!this.validation_document || !this.validation_document.list_inscriptions) return 0;

      return this.validation_document.list_inscriptions.length;
    },
  },
  methods: {
    async verify_webservice() {
      let request = await AdminService.validateWebservice(this.mainStore.module.id);
      if (!request.error) {
        this.fetch_list_webservice();
        this.snackbar_success = true;
      }
    },
    openDialogValidateDocument(inscription) {
      this.inscription_to_validate = inscription;
      this.show_validate = true;
    },
    openDialogRejectDocument(inscription) {
      this.inscription_to_validate = inscription;
      this.show_reject = true;
    },
    async handle_reject() {
      this.show_reject = false;
      this.inscription_to_validate.status = "rejected";
      let request = await AdminService.validateDocument(this.inscription_to_validate);
      if (!request.error) {
        this.fetch_list();
      }
    },
    async handle_validate() {
      this.show_validate = false;
      this.inscription_to_validate.status = "accepted";
      let request = await AdminService.validateDocument(this.inscription_to_validate);
      if (!request.error) {
        this.fetch_list();
      }
    },
    get_document_url(inscription) {
      let url = "";
      if (inscription.champs.type_document == "Licence" || inscription.champs.type_document == "Licence FFA" || inscription.champs.type_document == "Licence FFTRI" || inscription.champs.type_document == "Licence Experience") {
        url = inscription.champs.licence_document;
      } else if (inscription.champs.type_document == "Autre licence") {
        url = inscription.champs.autre_licence_document;
      }
      else if (inscription.champs.type_document == "Document PPS") {
        url = inscription.champs.pps_document;
      }
      else {
        url = inscription.champs.cm_document;
      }
      return url;
    },
    get_discipline(course) {
      let discipline = course.metadatas.find((m) => m.nom === "discipline");
      return discipline ? `(${discipline.valeur})` : "";
    },
    get_date_course(course) {
      return this.$moment(course.date_depart).format("DD/MM/YYYY");
    },

    async fetch_list_documents() {
      let request = await AdminService.getValidationDocumentsPendings(this.mainStore.module.id);
      if (!request.error) {
        this.validation_document = request;
      }
    },
    async fetch_list_webservice() {
      let request = await AdminService.getValidationWebservicePendings(this.mainStore.module.id);
      if (!request.error) {
        this.validation_webservice = request;
      }
    },
  },
  created() {

    this.fetch_list_documents();
    this.fetch_list_webservice();
  },
};
</script>

<style lang="scss" scoped></style>